import { loadable } from '@wix/communities-forum-client-commons/dist/src/services/loadable';

export const DevPlayground = loadable(() => import('./dev-playground'));
